// [src/pages/Payment/PaymentSuccess.jsx]

import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

function PaymentSuccess() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // 페이지 진입 시 응답 코드 확인 및 처리
    useEffect(() => {
        // URL 파라미터 추출
        const code = searchParams.get('code');
        const message = searchParams.get('message');
        const tid = searchParams.get('tid');

        // [중요] 에러 코드가 존재하면 실패 페이지로 리다이렉트
        // 페이레터는 성공 시 code가 null이거나 없지만, 실패 시에는 code 값이 존재합니다.
        if (code && code !== '') {
            console.warn(`❌ [PaymentSuccess] 결제 실패 감지 (Code: ${code})`);
            // 실패 페이지로 이동 (state로 에러 정보 전달)
            navigate('/payment/fail', {
                state: {
                    code: code,
                    message: message || '결제 진행 중 오류가 발생했습니다.'
                },
                replace: true // 뒤로가기 방지
            });
            return; // 이후 로직 실행 방지
        }

        // 쿼리 스트링을 그대로 유지해서 넘김
        const queryString = window.location.search.replace('?', '');

        // 0.5초 딜레이 후 네이티브 앱 호출
        const timer = setTimeout(() => {
            // 플러터의 shouldOverrideUrlLoading을 트리거하여 결제창을 닫고 데이터를 넘김
            window.location.href = `hypehaus://payment/success?${queryString}`;
        }, 500);

        return () => clearTimeout(timer);
    }, [searchParams, navigate]);

    // 홈으로 가기 (비상용 버튼)
    const handleGoHome = () => {
        window.location.href = "hypehaus://home";
        setTimeout(() => {
            window.location.replace('/');
        }, 500);
    };

    return (
        <div style={staticStyles.backgroundWrapper}>
            <main style={staticStyles.mainContent}>
                <div style={staticStyles.successSection}>
                    <div style={staticStyles.iconWrapper}>
                        <div style={staticStyles.checkIcon} />
                    </div>
                    <h2 style={staticStyles.successTitle}>결제가 완료되었습니다!</h2>
                    <p style={staticStyles.successDesc}>
                        하입하우스의 멤버가 되신 것을<br />환영합니다.
                    </p>
                </div>
            </main>

            <div style={staticStyles.bottomButtonWrapper}>
                <button style={staticStyles.confirmButton} onClick={handleGoHome}>
                    홈으로 가기
                </button>
            </div>
        </div>
    );
}

/** @type {React.CSSProperties} */
const staticStyles = {
    backgroundWrapper: {
        background: '#0D042D',
        width: '100%',
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        margin: '0 auto',
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden'
    },
    fixedHeaderWrapper: { position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 100, backgroundColor: '#0D042D' },
    statusBar: { flexShrink: 0, backgroundColor: 'transparent' },
    mainContent: {
        flex: 1,
        overflowY: 'auto',
        paddingTop: 'calc(env(safe-area-inset-top, 47px) + 50px)',
        paddingBottom: '100px',
        paddingLeft: '24px',
        paddingRight: '24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    successSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        marginBottom: '40px'
    },
    iconWrapper: {
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        background: 'rgba(128, 82, 255, 0.1)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '24px'
    },
    checkIcon: {
        width: '30px',
        height: '15px',
        borderLeft: '4px solid #8052FF',
        borderBottom: '4px solid #0231FB',
        transform: 'rotate(-45deg) translate(2px, -2px)'
    },
    successTitle: {
        fontFamily: 'Pretendard',
        fontWeight: '700',
        fontSize: '24px',
        color: '#FCFCFA',
        margin: '0 0 12px 0'
    },
    successDesc: {
        fontFamily: 'Pretendard',
        fontWeight: '400',
        fontSize: '16px',
        color: '#9A9A9A',
        lineHeight: '1.5',
        margin: 0
    },
    bottomButtonWrapper: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        padding: '24px 24px calc(env(safe-area-inset-bottom, 24px) + 24px)',
        boxSizing: 'border-box',
        backgroundColor: '#0D042D',
        zIndex: 100
    },
    confirmButton: {
        width: '100%',
        height: '56px',
        border: 'none',
        borderRadius: '8px',
        background: 'linear-gradient(90deg, #8052FF 0%, #0231FB 100%)',
        cursor: 'pointer',
        fontFamily: 'Pretendard',
        fontWeight: '700',
        fontSize: '16px',
        color: '#FFFFFF'
    },
};

export default PaymentSuccess;